module.exports = __webpack_public_path__ + "static/media/game-cvinterviewericon14.906a5f69.png";